import { render, staticRenderFns } from "./FindSection.vue?vue&type=template&id=b05b875a&scoped=true&"
import script from "./FindSection.vue?vue&type=script&lang=js&"
export * from "./FindSection.vue?vue&type=script&lang=js&"
import style0 from "./FindSection.vue?vue&type=style&index=0&id=b05b875a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05b875a",
  null
  
)

export default component.exports